import React from 'react'
import { getMapValue } from '@morningtrain/react-helpers'
import useCollection from '../collections/hooks/use-collection'
import useSelection from '../hooks/use-selection'
import useModelKeyName from '../hooks/use-model-key-name'
import { autorun } from 'mobx'

function ClearMissingSelectionOnExecute () {
  const collection = useCollection()
  const selection = useSelection()
  const modelKeyName = useModelKeyName()

  React.useEffect(() => {
    const disposer = autorun(() => {
      const ids = collection.map(entry => '' + getMapValue(entry, modelKeyName, null)).filter(v => v)
      const selected = selection.getSelected()

      if (selected.length > 0 && ids.length > 0) {
        selected.forEach((selectedId) => {
          if (!ids.includes(selectedId)) {
            selection.delete(selectedId)
          }
        })
      }
    }, { fireImmediately: true })

    return () => {
      disposer()
    }
  }, [collection, selection, modelKeyName])

  return null
}

export default ClearMissingSelectionOnExecute
